import React from 'react';
import PropTypes from 'prop-types';

const onDragStart = (e, draggedIndex) => {
    e.dataTransfer.setData('index', draggedIndex);
};

export const DragItem = ({
    id = 'drag-item',
    index,
    onOrderChange,
    style,
    ...props
}) => {
    const onDrop = (e) => {
        const draggedIndex = e.dataTransfer.getData('index');
        onOrderChange(index, draggedIndex);
    };

    style = {
        cursor: 'move',
        ...style
    };

    return (
        <td
            {...props}
            id={id}
            draggable
            style={style}
            onDragStart={(e) => onDragStart(e, index)}
            onDrop={onDrop}
        />
    );
};

DragItem.defaultProps = {
    id: 'drag-item'
};

DragItem.propTypes = {
    id: PropTypes.string,
    index: PropTypes.number.isRequired,
    onOrderChange: PropTypes.func.isRequired
};

export default DragItem;
